module.exports = __webpack_public_path__ + "static/media/ph-le-le.623839e9.png";